import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M15.636 5C18.046 5 20 6.977 20 9.416a4.428 4.428 0 01-1.534 3.363L12 19.4l-6.45-6.608A4.428 4.428 0 014 9.416C4 6.977 5.954 5 8.364 5c1.518 0 2.855.785 3.636 1.975A4.345 4.345 0 0115.636 5z"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
